import React from 'react';
import { Box } from '@mui/system';
import { Skeleton } from '@mui/material';

const PostReactionsSkeleton = () => {
    return (
        <Box>
            <Skeleton sx={{ width: 101, height: 48 }} variant="rectangular" />
            <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.12)', height: 2, width: '100%' }}></Box>
            <Box sx={{ ml: 1, mt: 2, display: 'flex', flexDirection: 'column', rowGap: 2 }}>
                {Array.from({ length: 9 }).map((val, index) => (
                    <Box key={index} sx={{ display: 'flex', alignItems: 'center' }}>
                        <Skeleton sx={{ width: 48, height: 48 }} variant="circular" />
                        <Skeleton sx={{ width: 120, height: 24, ml: 1 }} />
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default PostReactionsSkeleton;
